import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';

import InputTextArea from 'modules/_shared/components/InputTextArea';
import { useAddNoteModal } from '../context/AddNoteModalContext';

const AddNoteModalBody: FC = () => {
  const { t } = useTranslate();

  const MAX_COMMENT_LENGTH = 1000;
  const TEXT_AREA_HEIGHT = '150px';

  const { data, actions } = useAddNoteModal();

  return (
    <Modal.Body>
      <div className="form-group">
        <label htmlFor="annotation-date">{t('Date')}</label>
        <input
          id="annotation-date"
          type="datetime-local"
          className="form-control form-control-lg date-picker"
          value={data.date}
          onChange={actions.handleChangeDate}
        />
      </div>

      <div className="nk-modal">
        <div className="form-group">
          <InputTextArea
            id="annotation-text"
            label={t('Annotation')}
            value={data.text}
            onChange={actions.handleChangeText}
            maxLength={MAX_COMMENT_LENGTH}
            style={{ height: TEXT_AREA_HEIGHT }}
            noResize
            lgSize
          />
        </div>
      </div>
    </Modal.Body>
  );
};

export default AddNoteModalBody;
